import React from 'react';

import styled from 'styled-components';

import { LIVING_TYPES } from 'constants/livingTypes';
import { getAreaUnitLabel } from 'utils/helpers/units';

import { useShopDataModalContext } from '../ShopDataModalContext';

const Container = styled.div`
  margin-left: 216px;
  display: flex;
  gap: 10px;
  align-items: center;
  color: var(--text-tertiary);
  font-family: var(--font-bold);
  font-size: 12px;
`;

const BaseRentPlaceholder = styled.div`
  width: 120px;
`;

const SquareFootagePlaceholder = styled.div`
  width: 70px;
`;

const NotePlaceholder = styled.div`
  width: 50px;
`;

const ShopDataModalAccommodationEntryLabels = ({ showEntranceFeeLabel }: { showEntranceFeeLabel: boolean }) => {
  const { currentLivingType, unitSource } = useShopDataModalContext();
  const areaUnitLabel = getAreaUnitLabel(unitSource).toUpperCase();

  return (
    <Container>
      <BaseRentPlaceholder>
        {currentLivingType?.id === LIVING_TYPES.SKILLED_NURSING ? 'DAILY RATE' : 'MONTHLY FEE'}
      </BaseRentPlaceholder>
      {showEntranceFeeLabel && <BaseRentPlaceholder>ENTRANCE FEE</BaseRentPlaceholder>}
      <SquareFootagePlaceholder>{areaUnitLabel}</SquareFootagePlaceholder>
      <NotePlaceholder>NOTE</NotePlaceholder>
    </Container>
  );
};

export default ShopDataModalAccommodationEntryLabels;
